import { isUUID } from '@debbie/common/dist/imports/data/helpers.js'
import { useAllCreditors } from '@debbie/cortex/dist/creditors/index.js'
import { h } from '@debbie/cortex/dist/index.js'
import { RootState } from '@debbie/cortex/dist/reducer.js'
import CreditorSelect from '@debbie/iris/dist/components/CreditorSelect.js'
import { PageBase, Panel, TopNav } from '@debbie/iris/dist/components/index.js'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

type Props = {}

const IntegrationsPage = (props: Props) => {
  const history = useHistory()
  const lang = useSelector((state: RootState) => state.lang)
  const allCreditors = useAllCreditors()
  const creditor = useSelector((s: RootState) => s.selectedCreditor)

  useEffect(() => {
    if (h.isLoaded(allCreditors)) {
      if (allCreditors.data.length === 1) {
        history.push(`/${allCreditors.data[0].creditorId}/integrations`)
      } else if (creditor && isUUID(creditor)) {
        history.push(`/${creditor}/integrations`)
      }
    }
  }, [allCreditors])

  if (!h.hasData(allCreditors)) {
    return null
  }

  return (
    <>
      <TopNav />
      <PageBase>
        <Panel
          style={{
            maxWidth: '1400px',
            margin: '0px auto',
          }}
          header={lang.integrations.chooseCreditor}
        >
          <CreditorSelect
            value={null}
            onChange={(creditorId) => {
              if (creditorId != null) {
                history.push(`/${creditorId}/integrations`)
              }
            }}
          />
        </Panel>
      </PageBase>
    </>
  )
}

export default IntegrationsPage
